import { Button } from '@payaca/ambrosia';
import PayacaPhoneLink from '@payaca/components/payacaPhoneLink/PayacaPhoneLink';
import { FunctionComponent, type JSX } from 'react';

import './ContactUsCallout.sass';

type Props = {
  title?: string;
  children?: JSX.Element | JSX.Element[] | string;
};

const ContactUsCallout: FunctionComponent<Props> = ({
  title,
  children,
}: Props): JSX.Element => {
  return (
    <div className="contact-us-callout">
      {title && <h2>{title}</h2>}
      {children && <div className="children-container">{children}</div>}
      <div className="contact-us-prompt">
        <span className="grow">Need to speak to us?</span>
        <PayacaPhoneLink
          showPhoneIcon={false}
          anchorContent={<Button>0333 050 9475</Button>}
        />
      </div>
    </div>
  );
};

export default ContactUsCallout;
